import { Injectable } from '@angular/core';
import { ActiveCartService } from '@spartacus/cart/base/core';
import { ActiveCartAdapter } from './active-cart.adapter';
import { Cart, MultiCartFacade, OrderEntry } from '@spartacus/cart/base/root';
import { UserIdService, WindowRef } from '@spartacus/core';
import { distinctUntilChanged, map, Observable, switchMap } from 'rxjs';
import { StatusRequest } from '../../../../core/models/request-status.model';

@Injectable({
  providedIn: 'root',
})
export class CustomActiveCartService extends ActiveCartService {
  constructor(
    private _multiCartFacade: MultiCartFacade,
    private _userIdService: UserIdService,
    private _winRef: WindowRef,
    private activeCartAdapter: ActiveCartAdapter,
  ) {
    super(_multiCartFacade, _userIdService, _winRef);
  }

  override getActive(): Observable<Cart> {
    return this.activeCart$.pipe(
      map(cart => {
        let newCart: Cart = cart;

        if (cart.entries?.length) {
          newCart = {
            ...cart,
            ...{
              entries: this.parseEntries(cart.entries),
            },
            ...{
              // emailList: ['1teste@teste.com', '2teste@teste.com', '3teste@teste.com'],
              // shippingPreference: {
              //   code: 'x',
              //   label: 'Standard Delivery',
              // },
              // shippingPriority: {
              //   method: CUSTOM_DELIVERY_METHOD.CUSTOMER_PICKUP,
              //   subMethod: {
              //     code: 'standard-gross',
              //     // code: 'premium-gross',
              //     label: 'Standart Delivery',
              //     description: '(3-5 business days)',
              //     price: {
              //       formattedValue: '$ 10,99',
              //     },
              //   },
              //   carrier: {
              //     code: '321',
              //     label: 'Trasporter 1',
              //   },
              //   contractNumber: '123456',
              //   shippingAttention: 'Attention',
              //   shippingInstructions: 'Instructions',
              //   acknowledgment: {
              //     code: 'fax',
              //     label: 'Name',
              //   },
              // },
            }, // Mock your properties here
          };
        }

        return newCart;
      }),
    );
  }

  override getEntries(): Observable<OrderEntry[]> {
    return this.activeCartId$.pipe(
      switchMap(cartId => this.multiCartFacade.getEntries(cartId)),
      distinctUntilChanged(),
      map(entries => this.parseEntries(entries)),
    );
  }

  parseEntries(entries: OrderEntry[]): OrderEntry[] {
    return entries?.map(entry => {
      return {
        ...entry,
        ...{}, // Mock your properties here
      };
    });
  }

  clearPoLines(): Observable<StatusRequest> {
    return this.getActiveCartId().pipe(switchMap(cartId => this.activeCartAdapter.clearPoLines(cartId)));
  }

  updateNotes(entryID: number, notes: string): Observable<StatusRequest> {
    return this.getActiveCartId().pipe(switchMap(cartId => this.activeCartAdapter.updateNotes(cartId, entryID, notes)));
  }

  updateWarehouse(entryID: number, warehouseCode: string): Observable<StatusRequest> {
    return this.getActiveCartId().pipe(
      switchMap(cartId => this.activeCartAdapter.updateWarehouse(cartId, entryID, warehouseCode)),
    );
  }

  updateShipDate(entryID: number, date: Date | string): Observable<StatusRequest> {
    return this.getActiveCartId().pipe(
      switchMap(cartId => this.activeCartAdapter.updateShipDate(cartId, entryID, date)),
    );
  }

  updatePoLine(entryID: number, poLine: string): Observable<StatusRequest> {
    return this.getActiveCartId().pipe(
      switchMap(cartId => this.activeCartAdapter.updatePoLine(cartId, entryID, poLine)),
    );
  }
}
